import React from "react";
import "./certifications.css";

// ✅ All certificates as images (put these in src/assets/certs/)
import KaggleIntroML from "../../assets/certs/Naga Vamsi Reddy Satti - Intro to Machine Learning.png";
import KaggleExplainability from "../../assets/certs/Naga Vamsi Reddy Satti - Machine Learning Explainability.png";

import MicrosoftLearn from "../../assets/certs/microsoft-learn.png";
import MicrosoftFoundry1 from "../../assets/certs/microsoft-foundry-1.png";
import MicrosoftFoundry2 from "../../assets/certs/microsoft-foundry-2.png";

import SkillsBuild from "../../assets/certs/skillsbuild.png";
import NvidiaJetson from "../../assets/certs/nvidia-jetson.png";

const certifications = [
  {
    id: 1,
    title: "Intro to Machine Learning",
    issuer: "Kaggle",
    date: "Jan 2026",
    image: KaggleIntroML
  },
  {
    id: 2,
    title: "Machine Learning Explainability",
    issuer: "Kaggle",
    date: "Jan 2026",
    image: KaggleExplainability
  },
  {
    id: 3,
    title: "Microsoft Learn Achievements",
    issuer: "Microsoft Learn",
    date: "Jan 2026",
    image: MicrosoftLearn
  },
  {
    id: 4,
    title: "AI in Microsoft Foundry (Module 1)",
    issuer: "Microsoft Learn",
    date: "Jan 2026",
    image: MicrosoftFoundry1
  },
  {
    id: 5,
    title: "AI in Microsoft Foundry (Module 2)",
    issuer: "Microsoft Learn",
    date: "Jan 2026",
    image: MicrosoftFoundry2
  },
  {
    id: 6,
    title: "AI Trailblazer: Ready to shape AI",
    issuer: "IBM SkillsBuild",
    date: "Jan 2026",
    image: SkillsBuild
  },
  {
    id: 7,
    title: "Getting Started with AI on Jetson Nano",
    issuer: "NVIDIA",
    date: "Jan 2026",
    image: NvidiaJetson
  }
];

const Certifications = () => {
  return (
    <section className="certifications section" id="certifications">
      <h2 className="section__title">Certifications</h2>
      <span className="section__subtitle">Proof (images)</span>

      <div className="certifications__container container grid">
        {certifications.map((cert) => (
          <div key={cert.id} className="certifications__card">
            {/* Click image to open full size */}
            <a href={cert.image} target="_blank" rel="noreferrer">
              <img
                src={cert.image}
                alt={cert.title}
                className="certifications__img"
                loading="lazy"
              />
            </a>

            <h3 className="certifications__title">{cert.title}</h3>

            <div className="certifications__meta">
              <span className="certifications__issuer">{cert.issuer}</span>
              <span className="certifications__date">{cert.date}</span>
            </div>

            <a className="certifications__button" href={cert.image} target="_blank" rel="noreferrer">
              View Image
              <i className="bx bx-right-arrow-alt certifications__button-icon"></i>
            </a>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Certifications;
